@if(isBalanceLoaded()){
<div
  [ngxTippy]="tooltipTemplate"
  [tippyContext]="{ balance: balance() }"
  [tippyProps]="{
    placement: isRtl ? 'bottom-start' : 'bottom-end',
    hideOnClick: true,
    trigger: 'mouseenter focus',
    touch : false,
    arrow: false,
}"
  (click)="navigateToBilling()"
  [attr.aria-disabled]="!canNavigateToBilling()"
  [attr.tabindex]="canNavigateToBilling() ? 0 : -1"
  [ngClass]="[
    'tw-px-2 tw-py-1 lg:tw-px-2 lg:tw-py-2.5 dark:tw-bg-gray-800 tw-rounded-lg tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-inline-flex tw-justify-start tw-items-center tw-gap-1.5 tw-h-8',
    canNavigateToBilling() ? 'tw-cursor-pointer' : 'tw-cursor-not-allowed tw-opacity-60 tw-pointer-events-none',
    (balance() ?? 0) < 50
      ? 'tw-bg-red-60 tw-outline-red-600 dark:tw-outline-red-600 tw-text-red-600 dark:tw-text-red-600'
      : (balance() ?? 0) < 200
      ? 'tw-bg-yellow-50 tw-outline-yellow-500 dark:tw-outline-yellow-500 tw-text-yellow-500 dark:tw-text-yellow-500'
      : 'tw-bg-green-50 tw-outline-green-500 dark:tw-outline-green-500 tw-text-green-500 dark:tw-text-green-500'
  ]"
>
  <div class="tw-w-3 tw-h-3 md:tw-w-3.5 md:tw-h-3.5 tw-order-1 rtl:tw-order-2">
    <svg xmlns="http://www.w3.org/2000/svg" class="tw-w-3 tw-h-3 md:tw-w-3.5 md:tw-h-3.5" viewBox="0 0 14 14" fill="none">
      <g clip-path="url(#clip0_4966_28161)">
        <path
          d="M8.02667 2.76141L5.97956 0.282923C5.9142 0.204403 5.83318 0.139287 5.74127 0.091418C5.64937 0.0435486 5.54844 0.0138948 5.44445 0.0042058C5.23565 -0.0139247 5.02788 0.0482994 4.86656 0.17728L1.68856 2.76141H8.02667Z"
          [ngClass]="(balance() ?? 0) < 50 ? 'tw-fill-red-600 dark:tw-fill-red-600' : (balance() ?? 0) < 200 ? 'tw-fill-yellow-500 dark:tw-fill-yellow-500' : 'tw-fill-green-500'"
        />
        <path
          d="M6.22222 9.50456V8.75532C6.22222 7.96048 6.55 7.19819 7.13345 6.63615C7.71689 6.07412 8.50821 5.75836 9.33333 5.75836H13.2222V5.00913C13.2222 4.81041 13.1403 4.61984 12.9944 4.47933C12.8486 4.33882 12.6507 4.25989 12.4444 4.25989H0.777778C0.571498 4.25989 0.373667 4.33882 0.227806 4.47933C0.0819442 4.61984 0 4.81041 0 5.00913V13.2508C0 13.4495 0.0819442 13.64 0.227806 13.7806C0.373667 13.9211 0.571498 14 0.777778 14H12.4444C12.6507 14 12.8486 13.9211 12.9944 13.7806C13.1403 13.64 13.2222 13.4495 13.2222 13.2508V12.5015H9.33333C8.50821 12.5015 7.71689 12.1858 7.13345 11.6237C6.55 11.0617 6.22222 10.2994 6.22222 9.50456Z"
          [ngClass]="(balance() ?? 0) < 50 ? 'tw-fill-red-600 dark:tw-fill-red-600' : (balance() ?? 0) < 200 ? 'tw-fill-yellow-500 dark:tw-fill-yellow-500' : 'tw-fill-green-500'"
        />
        <path
          d="M13.2222 7.25684H9.33333C8.92077 7.25684 8.52511 7.41472 8.23339 7.69574C7.94167 7.97676 7.77778 8.3579 7.77778 8.75532V9.50456C7.77778 9.90198 7.94167 10.2831 8.23339 10.5641C8.52511 10.8452 8.92077 11.003 9.33333 11.003H13.2222C13.4285 11.003 13.6263 10.9241 13.7722 10.7836C13.9181 10.6431 14 10.4525 14 10.2538V8.00608C14 7.80737 13.9181 7.6168 13.7722 7.47629C13.6263 7.33578 13.4285 7.25684 13.2222 7.25684ZM10.5 9.87918C10.3462 9.87918 10.1958 9.83524 10.0679 9.75291C9.93998 9.67059 9.84029 9.55357 9.78143 9.41667C9.72256 9.27976 9.70716 9.12911 9.73717 8.98377C9.76718 8.83844 9.84125 8.70493 9.95003 8.60015C10.0588 8.49537 10.1974 8.42401 10.3483 8.3951C10.4991 8.36619 10.6555 8.38103 10.7976 8.43774C10.9398 8.49444 11.0612 8.59048 11.1467 8.71369C11.2322 8.8369 11.2778 8.98176 11.2778 9.12994C11.2778 9.32865 11.1958 9.51923 11.05 9.65974C10.9041 9.80025 10.7063 9.87918 10.5 9.87918Z"
          [ngClass]="(balance() ?? 0) < 50 ? 'tw-fill-red-600 dark:tw-fill-red-600' : (balance() ?? 0) < 200 ? 'tw-fill-yellow-500 dark:tw-fill-yellow-500' : 'tw-fill-green-500'"
        />
        <path
          d="M9.149 2.76141H11.1378L9.09067 0.282922C8.96215 0.127332 8.77474 0.0272918 8.56966 0.00481026C8.36458 -0.0176713 8.15863 0.039247 7.99711 0.163044C7.83559 0.28684 7.73174 0.467375 7.70841 0.664931C7.68507 0.862488 7.74415 1.06088 7.87267 1.21647L9.149 2.76141Z"
          [ngClass]="(balance() ?? 0) < 50 ? 'tw-fill-red-600 dark:tw-fill-red-600' : (balance() ?? 0) < 200 ? 'tw-fill-yellow-500 dark:tw-fill-yellow-500' : 'tw-fill-green-500'"
        />
      </g>
      <defs>
        <clipPath id="clip0_4966_28161">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>
  <div class="tw-text-xs md:tw-text-sm tw-font-medium md:tw-font-normal tw-font-inter md:tw-leading-none tw-order-2 rtl:tw-order-1">
    {{ balance() | currencyShortHand }}
  </div>
</div>
}

<ng-template #tooltipTemplate let-name let-data="data">
  <div class="tw-inline-flex tw-justify-center tw-items-center tw-gap-2.5">
    <div class="tw-inline-flex tw-flex-col tw-justify-start tw-items-start tw-gap-1">
      <span class="tw-text-gray-700 dark:tw-text-gray-100 tw-text-sm tw-font-semibold tw-font-inter tw-leading-normal">{{ 'v2.header.current_balance' | translate }}</span>
      <span
        class="tw-justify-start tw-text-sm tw-font-normal tw-font-inter tw-leading-normal"
        [ngClass]="
          (balance() ?? 0) < 50
            ? 'tw-text-red-600 dark:tw-text-red-600'
            : (balance() ?? 0) < 200
            ? 'tw-text-yellow-500 dark:tw-text-yellow-500'
            : 'tw-text-green-500 dark:tw-text-green-500'
        "
        >{{ balance() | currency }}</span
      >
    </div>
  </div>
</ng-template>
